import { ISignupNames } from "src/Module/Checkout/socialSignupNames";

/**
 * Read the name Apple sent back with a first authorisation.
 *
 * Apple puts the visitor's name in a `user` field on the form POST it makes to
 * the backend's callback, and `appleAuthCallbackV2` forwards that whole POST to
 * us as query parameters — so the name is already in the URL we are handed, next
 * to `id_token`. It is nowhere in the token itself.
 *
 * Apple sends it **once**, on the very first authorisation for that Apple ID, and
 * never again; and the visitor can decline to share it at the consent screen, in
 * which case the field arrives without a name. Both cases return null here, and
 * the caller falls back to asking.
 */
export const parseAppleUserParam = (raw?: string | null): ISignupNames | null => {
    if (!raw) return null;

    try {
        const parsed = JSON.parse(raw);
        const first = parsed?.name?.firstName;
        const last = parsed?.name?.lastName;
        if (typeof first !== "string" || typeof last !== "string") return null;
        if (first.trim() === "" || last.trim() === "") return null;
        return { first_name: first.trim(), last_name: last.trim() };
    } catch {
        // Malformed is the same as absent: the sign-in still proceeds, and the
        // visitor is asked for a name instead.
        return null;
    }
};
